export const decimalParser = (value: number, decimalPlaces: number) => {
  return Number(Math.round(parseFloat(value + 'e' + decimalPlaces)) + 'e-' + decimalPlaces);
};
